import { actions } from '@app/action/transfer';

export default function(state = {}, action) {
  const { type } = action;

  switch (type) {
    case actions.UPLOAD_PENDING:
      delete state['error'];
      return {
        ...state,
        isPending: true,
      };

    case actions.UPLOAD_ERROR_RESET:
      delete state['error'];
      return state;

    case actions.UPLOAD_RESET:
      delete state['error'];
      return {
        ...state,
        isPending: false,
      };

    case actions.UPLOAD_ERROR:
      return {
        ...state,
        error: action.error,
        isPending: false,
      };
  }

  return state;
}
